/* eslint react/prop-types: 0 */
/* eslint react/no-multi-comp: 0 */
/* eslint react/display-name: 0 */

import React from 'react';
import TextCell from 's1-ui/sovos-table/components/TextCell';
import CurrencyCell from 's1-ui/sovos-table/components/CurrencyCell';
import { addDashIfZero, formatCurrency } from 'shared/helpers/dataFormatHelper';

const columns = [
  {
    title: 'Line #',
    id: 1,
    style: {
      width: 70,
      flexShrink: 0
    },
    component: ({ content }) => <TextCell>{ content.number }</TextCell>
  },
  {
    title: 'Description',
    id: 2,
    style: {
      width: 400
    },
    component: ({ content }) => <TextCell>{ content.productDescription }</TextCell>
  },
  {
    title: 'Gross',
    id: 4,
    type: 'no-wrap',
    component: ({ content }) =>
      content.grossAmount !== undefined
      && content.grossAmount !== null ?
        <CurrencyCell formatCurrency={ formatCurrency } value={ content.grossAmount } /> : `-`
  },
  {
    title: 'Vendor Tax',
    id: 5,
    type: 'no-wrap',
    component: ({ content }) =>
      content.vendorTax !== undefined
      && content.vendorTax !== null
      && <CurrencyCell formatCurrency={ formatCurrency } value={ content.vendorTax } />
  },
  {
    title: 'Sovos Tax',
    id: 6,
    type: 'no-wrap',
    component: ({ content }) =>
      content.calculatedTax !== undefined
      && content.calculatedTax !== null
      && <CurrencyCell formatCurrency={ addDashIfZero } value={ content.calculatedTax } />
  },
  {
    title: '$ Var',
    id: 7,
    component: ({ content }) =>
      content.dollarVariance !==undefined
      && content.dollarVariance !== null
      && <CurrencyCell formatCurrency={ addDashIfZero } value={ content.dollarVariance } />
  },
  {
    title: '% Var',
    id: 8,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) => <TextCell>{ `${ content.percentVariance }%` }</TextCell>
  },
  {
    title: 'Updated',
    id: 9,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: () => <TextCell />
  }
];

export default columns;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesGrid/InvoicesLinesColumns.js